import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideReview {
  @autoserialize
  reservationId: number;

  @autoserialize
  driverRating: number;
}
